import React from 'react';


type PropsType = {
  html_content: string
}
const HTMLRenderer = ({html_content} : PropsType) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: html_content }} />
  );
};

export default HTMLRenderer;